import React from "react";
import { Outlet } from "react-router-dom";
import PropTypes from "prop-types";
import { Card, CardHeader, CardTitle } from "@tonic/shared/components/ui";

function ProductsLayout({ children }) {
  return (
    <div className="container mx-auto p-4">
      <Card>
        <CardHeader>
          <CardTitle>Products Management</CardTitle>
        </CardHeader>
        {children || <Outlet />}
      </Card>
    </div>
  );
}

ProductsLayout.propTypes = {
  children: PropTypes.node,
};

export { ProductsLayout }; 